export default __webpack_public_path__ + "static/media/Calf_milk_replacer.3019b97b.jpg";